/**
 * Canonical tool identifiers used across visualizer listeners and UI binders.
 * Keep these stable because persisted state and selectors depend on them.
 */
const TOOL = Object.freeze({
    BRUSH: 'brush',
    ERASER: 'eraser',
    MAGIC: 'magic',
    HAND: 'hand',
    DRAW_LINE: 'drawline',
    DRAW_POLY_MINUS: 'drawpolyminus',
    DRAW_POLY_PLUS: 'drawpolyplus',
})

export { TOOL }
